import { IJsonQuery } from '@cian/api-models/common/json_query';

import { TJsonQueryKey } from '../../../../JsonQuery';
import { COMMON_PROPERTIES } from './constants';

export function getUncommonProperties(jsonQuery: IJsonQuery): TJsonQueryKey[] {
  return (Object.keys(jsonQuery) as TJsonQueryKey[]).filter(property => !COMMON_PROPERTIES.includes(property));
}
